module.exports = __webpack_public_path__ + "static/img/maintain.a0fab3a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/maintain.svg
// module id = 0Dhu
// module chunks = 1